/**
 * Complete Your Product — tab filter + theme Slick (same as You may also like)
 */
(function () {
  function getRoot(el) {
    return el.closest('[data-upsell-root]');
  }

  function getActiveSlug(root) {
    const checked = root.querySelector('.product-upsell__radio:checked');
    return checked ? checked.value : 'all';
  }

  function cardMatchesSlug(card, slug) {
    if (slug === 'all') return true;
    return (card.dataset.category || '').trim() === slug;
  }

  function getCards(root) {
    return Array.from(
      root.querySelectorAll('.product[data-upsell-card]:not(.slick-cloned)')
    );
  }

  function getTrack(root) {
    return root.querySelector('.products-carousel') || root.querySelector('.products-grid');
  }

  function getStash(root) {
    return root.querySelector('[data-upsell-stash]');
  }

  function placeUpsellBadges(root) {
    getCards(root).forEach((card) => {
      const badges =
        card.querySelector(':scope > [data-upsell-badges]') ||
        card.querySelector(':scope > .product-upsell-card-badge');
      const media = card.querySelector('.card-media');
      if (!badges || !media || badges.parentElement === media) return;
      media.appendChild(badges);
    });
  }

  function isSliderMode(root) {
    return root.dataset.layoutMode === 'slider';
  }

  function teardownSlider(root) {
    const $ = window.jQuery;
    if (!$) return;

    const $root = $(root);
    const $block = $root.find('[data-product-block]');
    const $carousel = $block.find('.products-carousel');
    const track = getTrack(root);
    const cards = getCards(root);

    if ($carousel.length && $carousel.hasClass('slick-initialized')) {
      try {
        $carousel.slick('slickUnfilter');
        $carousel.slick('unslick');
      } catch (error) {
        /* ignore */
      }
    }

    $carousel.find('.slick-list, .slick-track, .slick-arrow, .slick-dots').remove();
    $block.find('.slick-arrow, .slick-dots').remove();
    $carousel.removeClass('slick-initialized slick-slider');

    if (!track) return;

    cards.forEach((card) => {
      card.classList.remove('slick-slide', 'slick-cloned', 'is-filtered-out');
      card.removeAttribute('style');
      card.removeAttribute('tabindex');
      card.hidden = false;
      track.appendChild(card);
    });
  }

  function initSlider(root) {
    const $ = window.jQuery;
    if (!$ || !isSliderMode(root)) return false;

    const $block = $(root).find('[data-product-block]');
    const $carousel = $block.find('.products-carousel');
    if (!$carousel.length) return false;

    const slideCount = $carousel.children('.product[data-upsell-card]').length;
    if (slideCount === 0) return false;

    if ($carousel.hasClass('slick-initialized')) {
      try {
        $carousel.slick('setPosition');
      } catch (error) {
        /* ignore */
      }
      return true;
    }

    const initFn =
      window.sharedFunctions?.productBlockSilder || window.halo?.productBlockSilder;

    if (typeof initFn !== 'function') return false;

    initFn($block);
    return $carousel.hasClass('slick-initialized');
  }

  function whenSliderReady(root, callback) {
    if (initSlider(root)) {
      callback();
      return;
    }

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (initSlider(root) || attempts >= 40) {
        window.clearInterval(timer);
        callback();
      }
    }, 150);
  }

  function updateEmptyState(root, visibleCount) {
    const empty = root.querySelector('[data-upsell-empty]');
    if (empty) {
      if (visibleCount === 0) {
        empty.removeAttribute('hidden');
      } else {
        empty.setAttribute('hidden', 'hidden');
      }
    }

    const track = getTrack(root);
    if (track) {
      track.classList.toggle('is-upsell-empty', visibleCount === 0);
    }
  }

  function applyGridFilter(root, visibleCards) {
    const cards = getCards(root);
    const visibleSet = new Set(visibleCards);

    cards.forEach((card) => {
      const match = visibleSet.has(card);
      card.classList.toggle('is-filtered-out', !match);
      card.hidden = !match;
      card.style.display = match ? '' : 'none';
    });

    updateEmptyState(root, visibleCards.length);
  }

  function applySliderFilter(root, visibleCards) {
    const track = getTrack(root);
    const stash = getStash(root);
    if (!track || !stash) return;

    teardownSlider(root);

    const allCards = getCards(root);
    const visibleSet = new Set(visibleCards);
    const sortedVisible = [...visibleCards].sort((a, b) => {
      const aOrder = parseInt(a.dataset.sortOrder, 10) || 999;
      const bOrder = parseInt(b.dataset.sortOrder, 10) || 999;
      return aOrder - bOrder;
    });

    sortedVisible.forEach((card) => {
      card.classList.remove('is-filtered-out');
      card.hidden = false;
      card.style.display = '';
      track.appendChild(card);
    });

    allCards.forEach((card) => {
      if (visibleSet.has(card)) return;
      card.classList.add('is-filtered-out');
      card.hidden = true;
      stash.appendChild(card);
    });

    updateEmptyState(root, visibleCards.length);

    if (visibleCards.length === 0) return;

    whenSliderReady(root, () => {
      placeUpsellBadges(root);
      const $ = window.jQuery;
      const $carousel = $(root).find('.products-carousel');
      if ($carousel.hasClass('slick-initialized')) {
        try {
          $carousel.slick('slickGoTo', 0, true);
          $carousel.slick('setPosition');
        } catch (error) {
          /* ignore */
        }
      }
    });
  }

  function applyFilter(root) {
    const slug = getActiveSlug(root);
    const cards = getCards(root);
    const visibleCards = cards.filter((card) => cardMatchesSlug(card, slug));

    if (isSliderMode(root)) {
      applySliderFilter(root, visibleCards);
    } else {
      applyGridFilter(root, visibleCards);
    }
  }

  function restoreAllCards(root) {
    const track = getTrack(root);
    const stash = getStash(root);
    if (!track || !stash) return;

    Array.from(stash.querySelectorAll('.product[data-upsell-card]')).forEach((card) => {
      card.classList.remove('is-filtered-out');
      card.hidden = false;
      track.appendChild(card);
    });
  }

  function sortCards(root) {
    const track = getTrack(root);
    if (!track) return;

    const sorted = getCards(root).sort((a, b) => {
      const aOrder = parseInt(a.dataset.sortOrder, 10) || 999;
      const bOrder = parseInt(b.dataset.sortOrder, 10) || 999;
      return aOrder - bOrder;
    });

    sorted.forEach((card) => track.appendChild(card));
  }

  function bindFilters(root) {
    root.querySelectorAll('.product-upsell__radio').forEach((radio) => {
      radio.addEventListener('change', () => applyFilter(root));
    });
    applyFilter(root);
  }

  function initRoot(root) {
    if (root.dataset.upsellBound === 'true') return;
    root.dataset.upsellBound = 'true';

    restoreAllCards(root);
    sortCards(root);
    placeUpsellBadges(root);
    bindFilters(root);
  }

  function initAll() {
    document.querySelectorAll('[data-upsell-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-upsell-root]');
    if (root) initRoot(root);
  });
})();
